import { ValueFormatterFunc, ValueFormatterParams } from 'ag-grid-community';

/* 
  Note: Value formatters are preferable over cell renderers, especially for large datasets.
  See: https://www.ag-grid.com/javascript-data-grid/scrolling-performance/#if-possible-avoid-cell-renderers
*/

// This generic function type alias adds an extra layer of strong typing to AG Grid's relaxed ValueFormatterFunc type alias.
// It ensures that a specific table field (TKey) is in the table data (TData) and matches the intended value type (TValue).
export type GenericValueFormatterFunc<TValue> = <
  TData extends { [key in TKey]: TData[TKey] & TValue },
  TKey extends keyof TData,
>(
  arg: ValueFormatterParams<TData, TData[TKey]>,
) => ReturnType<ValueFormatterFunc>;

export const EmptyCell = '-';
